export class PaginationInformation {
    currentPage: number;
    itemsPerPage: number;
    totalCount: number;

    get pageCount(): number {
        return Math.ceil(this.totalCount / this.itemsPerPage);
    }

    constructor() {
        this.currentPage = 1;
        this.itemsPerPage = 12;
        this.totalCount = 12;
    }
}